export const BATCH_ROW_TEST_ID = (id: number): string => `batch-row-${id}`;

export const BATCH_ROW_SUMMARY_TEST_ID = (id: number): string =>
  `batch-row-summary-${id}`;
